export const ConversationGroup = {
    UserSelfAssignedConversations: "UserSelfAssignedConversations",
    UserSelfSentConversations: "UserSelfSentConversations",
    TeamAssignedConversations: "TeamAssignedConversations",
    UserOtherAssignedConversations: "UserOtherAssignedConversations",
    // At the moment this is not an official rule present in the navigation, but it is accessible by entering the url with the right data
    UserOtherSentConversations: "UserOtherSentConversations",
} as const;
